<app-field-container [field]="this">
  <textarea
    class="form-control"
    [formControl]="control"
    [placeholder]="placeholder() ?? label() ?? ''"
    [maxlength]="maxLength()"
    [readonly]="readonly()"
    autosize>
  </textarea>
  <app-chars-left
    [maxLength]="maxLength()"
    [charsLeft]="charsLeft()"
    [charsLeftThreshold]="null">
  </app-chars-left>
</app-field-container>
